/** The Architecture page's sub-tabs, in order. Slugs are page routes — keep them stable. */
export const ARCH_TABS = [
  { slug: 'architecture', label: 'Overview' },
  { slug: 'architecture-deployment', label: 'Deployment' },
  { slug: 'architecture-aws-topology', label: 'AWS Topology' },
  { slug: 'architecture-domain-model', label: 'Domain Model' },
  { slug: 'architecture-environments', label: 'Environments' },
  { slug: 'architecture-hl7-integration', label: 'HL7 Integration' },
  { slug: 'architecture-api-security', label: 'API & Security' },
] as const

export type ArchSlug = (typeof ARCH_TABS)[number]['slug']

export function isArchPage(slug: string) {
  return slug === 'architecture' || slug.startsWith('architecture-')
}

export function archHref(slug: ArchSlug) {
  return `/wiki/dev-docs/${slug}`
}

export function archLabel(slug: ArchSlug) {
  return ARCH_TABS.find(t => t.slug === slug)?.label ?? slug
}
